import Filter from "components/Filter";
import Table from "components/Table";
import {
  BLOCK_FETCH_URL,
  DIVISION_FETCH_URL,
  ESTATE_FETCH_URL,
  LIST_SUPERVISOR_URL,
  REGION_FETCH_URL,
  SOS_STATUS,
  ZONE_FETCH_URL,
} from "configs/constants";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { fetchDataFromApi } from "../../utils";
import { useHistory } from "react-router-dom";
import { COMPANY_FETCH_URL } from "configs/constants";


let model = [
  { id: "sos_id", label: "SOS ID", type: "string" },
  { id: "created_at", label: "Date and Time", type: "date_time" },
  { id: "created_at", label: "Date and Time Created", type: "date_time" },
  { id: "worker_id_name", label: "Employee ID", type: "string" },
  { id: "status", label: "Status", type: "string" },
  { id: "estate", label: "Estate Name", type: "string" },
  { id: "supervisor", label: "Supervisor", type: "string" },
  { id: "attended_by_name", label: "Attended By", type: "string" },
];

// Please do not remove these lines of code
// const dateToday = new Date();
// const dateAfterThreeDays = new Date(
//   new Date().setDate(new Date().getDate() + 3)
// );

const pageNumberDropdown = true;


const SOSList = () => {
 
  const details = useLocation();
  const [supervisor, setSupervisor] = useState(null);
  const [selectedFormDate, setSelectedFormDate] = useState(null);
  const [selectedtoDate, setSelectedToDate] = useState(null);
  const history = useHistory();
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [disableZone, setDisableZone] = useState(true);


  useEffect(() => {
    fetchDataFromApi(LIST_SUPERVISOR_URL, setSupervisor, false);
  }, []);
  const getFormDate = (e) => {
    setSelectedFormDate(e);
  };
  const getToDate = (e) => {
    setSelectedToDate(e);
  };
  const today = new Date();
  const options = { timeZone: 'Asia/Kuala_Lumpur' };
  let date = today.toLocaleDateString('en-GB', options);
  date = date.split('/').reverse().join('-');

  const filterInitialValues = {
    date_from: details?.filters?.date_from || date,
    date_to: details?.filters?.date_to || date,
    sos_id: "",
    status: details?.filters?.status || null,
    company: "",
    zone: "",
    region: "",
    estate: "",
    division: "",
    supervisor_id: "",
    block: "",
  };
  let filters = {};
  if ("filters" in details) {
    if (details.filters.date_from && details.filters.date_to) {
      filters["date_from"] = details.filters.date_from;
      filters["date_to"] = details.filters.date_to;
    }
    if (details.filters.status) {
      filters["status"] = details.filters.status;
    }
    console.log("FILTERS", filters);

  }
  
  const [filterValues, setFilterValues] = useState(filters);
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const [disableDivision, setDisableDivision] = useState(true);
  const [disableBlock, setDisableBlock] = useState(true);
  const filterFields = [
    {
      type: "datepicker",
      label: "From Date",
      name: "date_from",
      emptyLabel: "DD/MM/YYYY",
      maxDate:selectedtoDate,
      getValue: getFormDate,
    },
    {
      type: "datepicker",
      label: "To Date",
      name: "date_to",
      emptyLabel: "DD/MM/YYYY",
      minDate: selectedFormDate,
      getValue: getToDate,
    },
    {
      type: "input",
      label: "SOS ID",
      name: "sos_id",
    },
    {
      type: "reactselect",
      label: "Supervisor",
      name: "supervisor",
      outerOptions: supervisor,
    },
    {
      type: "reactselect",
      label: "Status",
      name: "status",
      proxyUrl: SOS_STATUS,
      paginated: false,
    },
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      getValue: (e) => getCompanyValues(e, setDisableZone),
      paginated: true,
  
  
    },
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
       getValue: (e) => getZoneValues(e, setDisableRegion),
      paginated: true,
      disabled:disableZone,
      optionsDependsOn: "company",
    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: true,
      disabled:disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",
    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,
      paginated: true,
      disabled:disableEstate,
      getValue: (e) => getEstateValues(e, setDisableDivision),

      optionsDependsOn: "region",
    },
    {
      type: "reactselect",
      name: "division",
      label: "Division",
      proxyUrl: DIVISION_FETCH_URL,
      paginated: true,
      disabled:disableDivision,
      getValue: (e) => getDivisonValues(e, setDisableBlock),

      optionsDependsOn: "estate",
    },
    {
      type: "reactselect",
      name: "block",
      label: "Block",
      proxyUrl: BLOCK_FETCH_URL,
      paginated: true,
      disabled:disableBlock,

      optionsDependsOn: "division",
    },
  ];

  const actions = [
  //      {
  //   type: "view",
  //   title: "View",
  //   icon: <VisibilityIcon />,
  //   color: "secondary",
  //   onClick: (id) => history.push(`${history.location.pathname}/view-details/${id}`),
  // },
    
    "edit"];

  // useEffect(() => {
  //   fetchDataFromApi(SOS_STATUS, setSosChoices, false);
  // }, []);

  const onFilterRequest = (values) => {
    setFiltersApplied(true);
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
    
  };
  const clearFilter =()=>{
    filterInitialValues.status = null
    location.reload();
   }
   const getCompanyValues = (e, setDisableZone) => {
    if (!e || e.length === 0) {
      setDisableZone(true);
    }
    else {
      setDisableZone(false);
    }
  
  };

   const getZoneValues = (e,setDisableRegion) => {
    if (!e || e.length === 0) {
      setDisableRegion(true);
    }
    else {
      setDisableRegion(false);
    }
    
  };
  const getRegionValues = (e,setDisableEstate) => {
    if (!e || e.length === 0) {
      setDisableEstate(true);
    }
    else {
      setDisableEstate(false);
    }
    
  };
  
  const getEstateValues = (e,setDisableDivision) => {
    if (!e || e.length === 0) {
      setDisableDivision(true);
    }
    else {
      setDisableDivision(false);
    }
    
  };
  const getDivisonValues = (e,setDisableBlock) => {
    if (!e || e.length === 0) {
      setDisableBlock(true);
    }
    else {
      setDisableBlock(false);
    }
    
  };
  return (
    <>
      <div>
        <Filter
          initialValues={filterInitialValues}
          filterFields={filterFields}
          onSubmit={onFilterRequest}
          onClear={clearFilter}


          
        />
        {filtersApplied ? ( 

        <Table
          proxyURL="sos/bo-list/"
          actions={actions}
          model={model}
          excelExport={{ fileName: "SOSReport" }}
          filterValues={filterValues}
          noFilter
          noAddButton
          pageNumberDropdown={pageNumberDropdown}

        />
        ) : (
<Table
          proxyURL={null}
          actions={actions}
          model={model}
          excelExport={{ fileName: "SOSReport" }}
          filterValues={filterValues}
          noFilter
          noAddButton
          pageNumberDropdown={pageNumberDropdown}

        />
        )}
      </div>
    </>
  );
};

export default SOSList;
